<template>
  <div class="image-modal-container" v-click-outside="onCloseImageModal" @click.stop>
    <div class="image-modal-header">{{ modalComponent === 'image-save' ? $t('camstudy.stopwatch.setting.saveImage') : $t('camstudy.stopwatch.setting.changeImage') }}</div>
    <div class="image-modal-body">
      <div class="image-container">
        <div class="image-preview" ref="image-preview">
          <div class="image-preview-inner-header-container">
            <div class="image-preview-inner-header-text-container">
              <div class="today-date">{{formatTodayDays}}</div>
              <div class="today-study-time">{{ $t('camstudy.stopwatch.setting.todayTotal') }} {{formatTotalStudyTime}}<br />{{ $t('camstudy.stopwatch.setting.studied') }}</div>
            </div>
            <img class="grm-logo" src="@/assets/images/camstudy/logo_gooroomee.svg" alt="image" crossorigin="anonymous" />
          </div>
          <img class="custom-image" :src="getImageUrl" :alt="$t('common.image')" crossorigin="anonymous" />
          <div class="image-footer-container">
            <div class="current-time">{{ $t('camstudy.stopwatch.setting.currentTime') }} <b>{{formatTimeNow}}</b></div>
            <div class="grm-message">{{ $t('camstudy.stopwatch.setting.studyWithGooroomee') }}</div>
          </div>
        </div>
      </div>
      <div class="image-control-container" v-if="modalComponent === 'image-save'">
        <button class="control-button" @click="onChangeComponent">{{ $t('camstudy.stopwatch.setting.changeImage') }}</button>
        <button class="control-button" @click="onReloadTime">{{ $t('camstudy.stopwatch.setting.refresh') }}</button>
      </div>
      <div class="image-control-container" v-else-if="modalComponent === 'image-change'" @click="onChangeImage">
        <button class="image-control image1" :class="{active: tempSelectedImage === 'image1'}" value="image1"></button>
        <button class="image-control image2" :class="{active: tempSelectedImage === 'image2'}" value="image2"></button>
        <button class="image-control image3" :class="{active: tempSelectedImage === 'image3'}" value="image3"></button>
        <button class="image-control upload" value="upload" @click.stop @change="onUploadImage">
          <input type="file" class="input-file" />
        </button>
      </div>
    </div>
    <div v-if="modalComponent === 'image-save'" class="image-modal-footer">
      <button class="footer-button cancel" @click="onCloseImageModal">{{ $t('common.cancel') }}</button>
      <button class="footer-button save" @click="onSaveImage">{{ $t('common.save') }}</button>
    </div>
    <div v-else-if="modalComponent === 'image-change'" class="image-modal-footer">
      <button class="footer-button cancel" @click="onChangeComponent">{{ $t('common.prev') }}</button>
      <button class="footer-button save" @click="onSaveChangeImage">{{ $t('common.confirm') }}</button>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import html2canvas from "html2canvas";
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'CamStudySaveStudyImage',
  data(){
    return {
      modalComponent: '',
      selectedImage: 'image1',
      tempSelectedImage: 'image1',
      customImage: '',
      days: dayjs(),
      formatTotalStudyTime: '',
      isDownloading: false,
    }
  },
  computed: {
    ...mapGetters('camstudy', ['getUserStudyData']),
    ...mapGetters('user', ['me']),
    getImageUrl() {
      if((this.modalComponent === 'image-save' ? this.selectedImage : this.tempSelectedImage) === 'upload') {
        return this.customImage;
      }
      return require(`@/assets/images/camstudy/gooroomee_study_download_${this.modalComponent === 'image-save' ? this.selectedImage : this.tempSelectedImage}.png`)
    },
    formatTodayDays(){
      return this.days.format('YYYY.MM.DD ddd')
    },
    formatTimeNow(){
      return this.days.format('A HH:mm')
    },
    studyData() {
      return this.getUserStudyData(this.me.userId)
    },
  },
  mounted() {
    this.modalComponent = 'image-save';
    this.closeControlMenu();
    this.onReloadTime();
  },
  methods: {
    ...mapActions('common', ['closeControlMenu']),
    onChangeComponent(){
      if(this.modalComponent === 'image-save'){
        this.tempSelectedImage = this.selectedImage;
        this.modalComponent = 'image-change'
      }else{
        this.modalComponent = 'image-save'
      }
    },
    onChangeImage(e){
      this.tempSelectedImage = e.target.value;
    },
    onUploadImage(e){
      this.tempSelectedImage = 'upload';
      if (!e.target.files) return;
      const file = e.target.files[0];
      if (file) {
        const img = new Image()
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          const originalWidth = img.width;
          const originalHeight = img.height;
          const targetAspectRatio = 16 / 9;

          let cropWidth = originalWidth;
          let cropHeight = originalWidth / targetAspectRatio;

          if (cropHeight > originalHeight) {
            cropHeight = originalHeight;
            cropWidth = cropHeight * targetAspectRatio;
          }

          const startX = (originalWidth - cropWidth) / 2;
          const startY = (originalHeight - cropHeight) / 2;

          canvas.width = cropWidth;
          canvas.height = cropHeight;
          canvas.style.width = cropWidth + 'px';
          canvas.style.height = cropHeight + 'px';

          ctx.drawImage(img, startX, startY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
          document.body.appendChild(canvas);

          this.customImage = canvas.toDataURL('image/png');

          canvas.remove()
          img.remove()
        }
      }
    },
    onCloseImageModal(){
      this.$modal('CamStudySaveStudyImage')
    },
    onSaveChangeImage(){
      this.selectedImage = this.tempSelectedImage;
      this.modalComponent = 'image-save';
    },
    onSaveImage(){
      if(this.isDownloading){
        return;
      }
      this.isDownloading = true
      html2canvas(this.$refs['image-preview'], {windowWidth: 1264, windowHeight: 1264, scale: 4}).then((res) => {
        const imageUrl = res.toDataURL('image/png');
        const a = document.createElement('a');
        try{
          a.href = imageUrl;
          a.download = 'image.png';
          document.body.append(a);
          a.click();
        }finally{
          window.URL.revokeObjectURL(imageUrl);
          a.remove();
        }
      }).finally(()=>{
        this.isDownloading = false;
      });

      // @todo html2canvas 수정
      // console.log(this.$refs['image-preview'].clientWidth, this.$refs['image-preview'].clientHeight)
      // console.log(this.selectedImage, this.customImage);
    },
    formatTime(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      // const secs = seconds % 60;

      const paddedHours = hours.toString().padStart(2, '0');
      const paddedMinutes = minutes.toString().padStart(2, '0');
      // const paddedSeconds = secs.toString().padStart(2, '0');

      return this.$t('camstudy.stopwatch.timeFormat', { hours: paddedHours, minutes: paddedMinutes });
    },
    onReloadTime(){
      this.days = dayjs();
      this.formatTotalStudyTime = this.formatTime( this.studyData?.time || 0)
    },
  }
}
</script>

<style scoped lang="scss">
[grm-device-mobile]{
  .image-modal-cover{
    @media (orientation: portrait) {
      bottom: 64px;
    }
    @media(orientation: landscape) {
      bottom: 98px;
    }
  }
}
html:not([grm-device-mobile]){
  .image-modal-cover{
    bottom: 80px;
  }
}
.image-modal-cover{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;

  z-index: 100;
  background: rgba(0, 0, 0, 0.5);
  .stopwatch-setting-container{
    position: absolute;
    color: white;
    z-index: 100;
    bottom: 0;
    left: 0;
    width: 100%;
  }
}

[grm-device-mobile] .image-modal-container{
  @media(orientation: portrait) {
    left: 8px;
    right: 8px;
    bottom: 8px;
  }
  @media(orientation: landscape) {
    bottom: 34px;
    left: 50%;
    transform: translateX(-50%);
    max-height: calc(100% - 57px);
    .image-modal-body{
      height: calc(100dvh - 57px - 112px);
      overflow-y: scroll;
    }
  }
}

html:not([grm-device-mobile]) .image-modal-container{
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 360px;
}

.image-modal-container{
  position: absolute;
  padding-top: 6px;
  z-index: 2;
  border-radius: 12px;
  background: #313131;
  color: white;
  font-size: 14px;
  .image-modal-header{
    text-align: center;
    height: 44px;
    padding: 10px 20px;
    line-height: 1.5;
  }
  .image-modal-body{
    overflow-x: hidden;
    .image-container{
      padding: 12px 20px;
      .image-preview{
        max-width: 316px;
        aspect-ratio: 1 / 1;
        margin: 0 auto;
        max-height: 316px;
        border-radius: 6px;
        background: #FFF;
        padding: 30px 24px;
        color: #000;
        .image-preview-inner-header-container{
          display: flex;
          justify-content: space-between;
        }
        .image-preview-inner-header-text-container {
          .today-date {
            font-size: 12px;
            margin-bottom: 3px;
            line-height: 14px;
            height: 14px;
          }
          .today-study-time{
            font-size: 20px;
            font-weight: 700;
            line-height: 130%;
            height: 52px;
          }
        }
        .grm-logo{
          width: 45.92px;
          height: 28px;
        }
        .custom-image{
          object-fit: cover;
          width: 100%;
          aspect-ratio: 268/149;
          margin: 12px 0;
        }
        .image-footer-container{
          display: flex;
          font-size: 12px;
          justify-content: space-between;
          line-height: 14px;
          height: 14px;
        }
      }
    }
    .image-control-container{
      display: flex;
      padding: 12px 20px;
      justify-content: space-between;
      gap: 10px;
      .control-button {
        border-radius: 10px;
        background: #1F1F1F;
        width: 100%;
        color: #FFF;
        text-align: center;
        font-size: 14px;
        line-height: 150%;
        padding: 12px;
      }
      .image-control{
        background-color: #F1F1F1;
        border-radius: 6px;
        width: 100%;
        aspect-ratio: 1/1;
        position: relative;

        &.active{
          &::before {
            content: "";
            width: 100%;
            height: 100%;
            background: rgba(1, 111, 242, 0.50) url("~@/assets/images/camstudy/ico_check_white.svg") no-repeat center;
            background-size: auto 24px;
            border-radius: 6px;
            border: 4px solid #016FF2;
            position: absolute;
            top: 0;
            left: 0;
          }
        }

        &.upload{
          position: relative;
          background: #1F1F1F url("~@/assets/images/camstudy/ico_upload_white.svg") center no-repeat;
          .input-file{
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            opacity: 0;
            appearance: none;
            -webkit-appearance: none;
            -moz-appearance: none;
            &::before{
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background: transparent;
            }
          }
        }
        &.image1{
          background: url("~@/assets/images/camstudy/gooroomee_study_download_image1.png") center no-repeat;
          background-size: auto 100%;
        }
        &.image2{
          background: url("~@/assets/images/camstudy/gooroomee_study_download_image2.png") center no-repeat;
          background-size: auto 100%;
        }
        &.image3{
          background: url("~@/assets/images/camstudy/gooroomee_study_download_image3.png") center no-repeat;
          background-size: auto 100%;
        }
      }
    }
  }
  .image-modal-footer{
    display: flex;
    border-top: 0.333px solid rgba(255, 255, 255, 0.20);
    margin-top: 12px;
    .footer-button{
      width: 100%;
      padding: 15px 0 14px 0;
      text-align: center;
      font-size: 14px;
      line-height: 150%;

      &.cancel{
        font-weight: 400;
        color: #999;
      }
      &.save{
        color: #FFF;
        font-weight: 700;
      }
    }
  }
}
</style>